import { c as _c } from "react/compiler-runtime";
import type { FetchChatTranslateParams } from '@module/apis/client-side/chat/type';
import { PendingSpinner } from '@module/components/Button/PendingSpinner';
import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import type { NormalChatMessage } from '@module/types/centrifuge/public-message';
import { useEffect, useRef } from 'react';
import useChatTranslate from './useChatTranslate';
interface Props {
  chatData: NormalChatMessage;
  setTranslatedMessage: (message: string) => void;
  filtered?: boolean;
  filteredMessage?: string;
  className?: string;
  onError: ((error: Error, variables: FetchChatTranslateParams, context: unknown) => Promise<unknown> | unknown) | undefined;
  // 해당 방송의 bj인지 여부(offset 전달용)
  isRoomMaster?: boolean;
}

/**
 * BJ 자동 번역 케이스: 마운트 시 즉시 번역 요청을 1회 발화하고,
 * 번역 중에는 (버튼 대신) 작은 pending 인디케이터를 표시. 완료 후엔 아무것도 렌더하지 않으며
 * 번역 결과는 상위 NormalChat의 기존 translatedMessage 블록이 표시.
 */
function AutoChatTranslate(t0) {
  const $ = _c(16);
  const {
    chatData,
    setTranslatedMessage,
    filtered,
    filteredMessage,
    className,
    onError,
    isRoomMaster
  } = t0;
  let t1;
  if ($[0] !== chatData || $[1] !== filtered || $[2] !== filteredMessage || $[3] !== isRoomMaster || $[4] !== onError || $[5] !== setTranslatedMessage) {
    t1 = {
      chatData,
      setTranslatedMessage,
      filtered,
      filteredMessage,
      onError,
      isRoomMaster
    };
    $[0] = chatData;
    $[1] = filtered;
    $[2] = filteredMessage;
    $[3] = isRoomMaster;
    $[4] = onError;
    $[5] = setTranslatedMessage;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    translate,
    isPending
  } = useChatTranslate(t1);
  const hasFiredRef = useRef(false);
  let t2;
  let t3;
  if ($[7] !== translate) {
    t2 = () => {
      if (hasFiredRef.current) {
        return;
      }
      hasFiredRef.current = true;
      translate();
    };
    t3 = [translate];
    $[7] = translate;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  if (!isPending) {
    return null;
  }
  let t4;
  if ($[10] !== className) {
    t4 = cn("flex items-center gap-1.5 text-colorFg16", className);
    $[10] = className;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PendingSpinner size={12} />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-[12px]">{SettingConfig.LANG !== "ko" ? "\u7FFB\u8A33\u4E2D" : "\uBC88\uC5ED \uC911"}</span>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[14] = t4;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
export default AutoChatTranslate;